import { Header } from '@components/Header';
import { OutlinedLink } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { PageErrorState } from '@components/core-ui/PageErrorState';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';

import { usePageContext } from '../../providers/PageProvider';
import { Table } from './components/Table';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { me } = useAuthContext();
  const {
    users,
    page,
    setPage,
    pageSize,
    setPageSize,
    search,
    setSearch,
    sortingField,
    sortingReverse,
    isLoading,
    hasInitialError,
    retryUsers,
    changeEnabled,
    verifyEmail,
    confirmUser,
    toggleSort,
    createUser,
    exportCSV,
  } = usePageContext();

  return (
    <>
      <Helmet>
        <title>Users list - AutoScript Admin</title>
      </Helmet>
      <Header
        title="Users"
        buttonLabel={users.data?.length ? 'Export CSV' : undefined}
        buttonOnClick={users.data?.length ? () => exportCSV() : undefined}
        secondButtonLabel={'Create user'}
        secondButtonOnClick={() => createUser()}
        setSearch={setSearch}
        search={search}
        leftSideContent={[
          <OutlinedLink key="MyRecord" to={routes.adminUserDetails.make(me.id)}>
            View my record
          </OutlinedLink>,
        ]}
      />

      <LinearProgressLoader active={isLoading} />
      <Wrapper>
        {hasInitialError ? (
          <PageErrorState
            message="Couldn't load users"
            actionLabel="Retry"
            actionDisabled={isLoading}
            onAction={retryUsers}
          />
        ) : (
          <Table
            users={users}
            sorting={{ field: sortingField, reverse: sortingReverse, toggle: toggleSort }}
            page={page}
            onPageChange={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            currentUserId={me.id}
            onToggleEnabled={changeEnabled}
            onVerifyEmail={verifyEmail}
            onConfirmUser={confirmUser}
          />
        )}
      </Wrapper>
    </>
  );
};
